import type { LogErrorBeforeSend } from '@zg-rentals/log-error';

// Known third-party scripts whose failures reach logError but aren't ours to fix: GTM tags
// calling GA when it's blocked, the PerimeterX bootstrap served from /<pxAppId>/init.js, and
// Pinterest conversion-tag network failures. The filename comes from the global error
// handler's context; rejections carry no filename, so those match on message only.
const THIRD_PARTY_ERRORS: ReadonlyArray<{ message?: RegExp; filename?: RegExp }> = [
  { message: /\bga is not defined\b|Can't find variable:? ga\b/ },
  { filename: /\/[A-Za-z0-9]{6,12}\/init\.js$|perimeterx|px-cloud/ },
  { message: /ct\.pinterest\.com|s\.pinimg\.com/ },
];

// A logError beforeSend that discards known third-party noise so it is never reported.
export const discardThirdPartyErrors: LogErrorBeforeSend = ({ message, context }) => {
  const filename = typeof context.filename === 'string' ? context.filename : '';
  const isThirdParty = THIRD_PARTY_ERRORS.some(
    (candidate) =>
      (candidate.message != null && candidate.message.test(message)) ||
      (candidate.filename != null && candidate.filename.test(filename)),
  );

  if (isThirdParty) {
    return false;
  }
};
